import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { ContentManagementService } from "app/content-management/content-management.service";
import { ApiService } from "app/modules/shared/services/api.service";
import * as moment from "moment";
import { TableComponent } from "../../table/table.component";
import * as _ from "underscore";
import { debounceTime, distinctUntilChanged, Subject, Subscription } from "rxjs";
import * as FileSaver from "file-saver";
import { AlertMessage } from "app/shared/utils/alertMessage";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AnalyticService } from "app/modules/shared/services/analytic.service";
import { UserData } from "app/shared/service/UserService";
import * as momenttz from "moment-timezone";
import { DateRangeComponent } from "../../date-range/date-range.component";
import { HelperService } from "app/modules/shared/services/helper.service";
import { HighchartsComponent } from "app/modules/shared/highcharts/highcharts.component";
import { CryptoService } from "app/shared/utils/crypto.service";
import { resolveAxisAnchorDate } from "app/shared/utils/analytics-axis.util";
interface UsageAnalytics {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-atc-practice-set-analytics',
  templateUrl: './atc-practice-set-analytics.component.html',
  styleUrls: ['./atc-practice-set-analytics.component.scss']
})
export class AtcPracticeSetAnalyticsComponent implements OnInit, OnDestroy {
  updateChart = false;
  @ViewChild("highchartsComponent") highchartsComponent: HighchartsComponent;
  @Input() isGraphOnly: boolean = false;
  @Input() flexWidth: any;
  @Input() dateData$: Subject<any>;
  @Input() selectedApp: any;
  dateRangeType = "Month";
  subSink: Subscription;
  appSubSink: Subscription;
  @Output() exit = new EventEmitter();
  liveSessionDates: any;
  key: string;
  liveSessionUsageList = [];
  liveSessionChartDatasets: Array<any>;
  liveSessionChartLabels: Array<any> = [];
  usageDateRange: any;
  usageDates: any;
  typeUser: string = "Month";
  typeRecords: string = "Month";
  typeUsage: string = "Month";
  typeLiveSession: string = "Month";
  data = {
    users: undefined,
    records: undefined,
    id: undefined,
    name: undefined,
  };
  folderName: any;
  usageColors = [
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(215, 38, 61)",
      borderWidth: 2,
      name: "Session Played",
    },
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(112, 0, 152)",
      borderWidth: 2,
      name: "Num. Of Users",
    },
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(45, 134, 86)",
      borderWidth: 2,
      name: "Times Mastered",
    },
  ];
  liveSessionColors = [
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(0,118,187)",
      borderWidth: 2,
      name: "Correct Answer",
    },
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgb(215, 38, 61)",
      borderWidth: 2,
      name: "Incorrect Answer",
    },
    {
      backgroundColor: "rgba(255, 255, 255, .2)",
      borderColor: "rgba(255, 86, 3, 1)",
      borderWidth: 2,
      name: "Incorrect Sessions",
    },
  ];
  dateType: any = { type: "Month" };
  @Input() psParams: any;
  breadCrumb: any;
  breadCrumbUser: any;
  dataId: string;
  selectedUsage: string;
  dateInfo: any;
  constructor(
    public analyticService: AnalyticService,
    public route: ActivatedRoute,
    public api: ApiService,
    public dialog: MatDialog,
    public router: Router,
    public contentManagementService: ContentManagementService,
    public fb: FormBuilder,
    public hs: HelperService,
    private crypto: CryptoService
  ) {
    this.organizationId = "noOrg";
    if (!_.isUndefined(UserData.organizationId) && UserData.organizationId != "") this.organizationId = UserData.organizationId;
    else if (!_.isUndefined(localStorage.getItem("organizationId"))) this.organizationId = localStorage.getItem("organizationId");
    this.organizationId = this.organizationId == null ? "noOrg" : this.organizationId;

    this.masteredPracticeSetsForm = fb.group({
      masteredPSetsPlayedDate: [{ begin: new Date(), end: new Date() }],
    });
    let timezone = localStorage.getItem("timeZone");
    this.userTimeZone = momenttz().tz("America/New_York");

    const formattedTime = this.userTimeZone.format("YYYY-MM-DD HH:mm:ss");
    let word: any = JSON.parse(localStorage.getItem("breadCrumb"));
    this.breadCrumb = word[0].name;
    const userIndex = word.filter((v) => v.icon == "fa fa-user");
    if (userIndex && userIndex.length > 0) {
      this.breadCrumbUser = userIndex[0].name;
    }
    this.dataId = this.route.snapshot.params["id"];
  }

  ngOnChanges() {
  }

  getDate(e) {
    this.api.changeMessage(e);
  }
  getDynamicHeight(): number {
    // Your logic to calculate the dynamic height goes here
    // return 2 * 50; // Replace this with your actual logic
    const parentElement = document.getElementById("parentElement");
    const parentWidth = parentElement.clientWidth;
    return parentWidth;
  }
  getDynamicHeight1(): number {
    // Your logic to calculate the dynamic height goes here
    // return 2 * 50; // Replace this with your actual logic
    const parentElement = document.getElementById("parentElement1");
    const parentWidth = parentElement.clientWidth;
    return parentWidth;
  }
  getDynamicHeight2(): number {
    // Your logic to calculate the dynamic height goes here
    // return 2 * 50; // Replace this with your actual logic
    const parentElement = document.getElementById("parentElement2");
    const parentWidth = parentElement.clientWidth;
    return parentWidth;
  }
  openUserDialog() {
    if (this.key !== "pSetAnalytics") {
      this.dialog.open(TableComponent, {
        data: {
          api: "/analytics/practicesets/" + this.data.id + "/practiceSetActiveUsersUsageDetails?",
          header: "Users/Nickname",
          rediretionUrl: "main/user/details",
          redirectionKey: "username",
          dateParameter: "PracticeSet",
        },
        width: "900px",
        maxWidth: "95vw",
        maxHeight: "90vh",
        panelClass: "table-dialog",
      });
    }

  }

  async getUsers(e) {
    console.log(this.selectedApp);
    this.data.users = undefined;

    let nameStr = this.crypto.isProbablyEncrypted(this.breadCrumbUser) ? this.breadCrumbUser : await this.crypto.encryptData(this.breadCrumbUser);
    this.api
      .get(
        "/analytics/sessionsUserAnalytics?" +
        (e.date ? e.date : "usageType=" + e.type.toLowerCase()) +
        "&gameId=" +
        this.selectedApp.id +
        (this.data.id ? "&dataId=" + this.data.id : "") +
        (this.breadCrumbUser ? "&userName=" + nameStr : "")
      )
      .subscribe(
        (success) => {
          if (success && success.length > 0) {
            success = success.sort((a, b) => new Date(b["sessionDate"]).getTime() - new Date(a["sessionDate"]).getTime());
            this.data.users = success.map((data) => {
              data = {
                ...data,
              };
              const date = moment(data["sessionDate"]).format("MMMM D, YYYY");
              data["sessionDate"] = date;

              return data;
            });
          } else {
            this.data.users = [];
          }
        },
        (err) => {
          this.getError(err);
        }
      );
  }

  getListOfRecords(e) {
    if (this.data.id) {
      this.data.records = undefined;
      this.api.get("/analytics/practicesets/" + this.data.id + "/pratSetQuesRecordAnalyticsUsage?" + (e.date ? e.date : e.type.toLowerCase() + "=" + e.type.toLowerCase())).subscribe(
        (success) => {
          if (success && success.QuestionRecords) {
            this.data.records = success.QuestionRecords.map((data) => {
              delete data.id;
              data = {
                recordNumber: data.recordNumber,
                "#Shown": data.shown,
                "#Correct": data.numberCorrect,
                "#Incorrect": data.numberIncorrect,
                "%Correct": data.correctPercentage,
              };
              return data;
            });
          } else {
            this.data.records = [];
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    }
  }

  getNoOfQuesLabels() {
    let quesLabels = [];
    for (let i = 1; i <= this.liveSessionUsageList.length; i++) {
      quesLabels.push("Question " + i);
    }
    return quesLabels;
  }

  getLastFiveWeeks() {
    let noOfWeeks = [];
    for (let i = 1; i <= 5; i++) {
      noOfWeeks.push("Week " + i);
    }
    return noOfWeeks;
  }

  // SG-8323 (Issue 8): the x-axis used to be built from the browser's "today" while the series
  // came from the server's window starting at the requested `fromDate`. Any disagreement
  // between the two clocks (the client runs IST, the API window is server-side) shifted every
  // label by a day — the graph started at May 20 for data the API returned from May 19. Anchor
  // the labels to the same `from` date that was sent to the API so they cannot drift.
  getLastThirtyDaysDefault(data) {
    let daysDate = [];
    const anchorDate = resolveAxisAnchorDate(data);
    for (let i = 0; i < data.count; i++) {
      let date = new Date(anchorDate);
      if (data.type === "month" || data.type === "Month") {
        const selectedMonth = moment(date).subtract(i, "months");
        daysDate.push(moment(selectedMonth).format("MMM YYYY"));
        console.log("daysDate - ", daysDate);
      } else if (data.type === "year" || data.type === "Year") {
        var selectedYear = moment(date).subtract(i, "years");
        daysDate.push(moment(selectedYear).format("YYYY"));
      } else {
        date.setDate(date.getDate() - i);
        daysDate.push(moment(date).format("ddd, MMM D"));
      }
    }
    return daysDate.reverse();
  }

  getDatesBetweenStartAndEndDefault(startDate, endDate) {
    let date = [];
    endDate = moment(endDate).add(1, "days").format("YYYY-MM-DD");
    while (moment(startDate) <= moment(endDate)) {
      date.push(moment(startDate).format("ddd, MMM D"));
      startDate = moment(startDate).add(1, "days").format("YYYY-MM-DD");
    }
    return date;
  }

  getLastThirtyDays(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }

  getLastTwentyFourMonth(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1);

      return date.toLocaleDateString("en-US", {
        month: "short",
        year: "numeric"
      });
    });
  }

  getDatesBetweenStartAndEnd(timepointPlayed: string[]): string[] {
    return timepointPlayed.map(dateStr => {
      const [month, day, year] = dateStr.split("-").map(Number);
      const date = new Date(year, month - 1, day);

      return date.toLocaleDateString("en-US", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
    });
  }

  async getUsageRecords(type: any, usageType?: any) {
    this.updateChart = false;
    let selectData: string = type.type;
    let count = type.count;
    let date;
    let startDate;
    let endDate;
    let apiUrl;
    const dataID = this.dataId;
    let nameStr = this.crypto.isProbablyEncrypted(this.breadCrumbUser) ? this.breadCrumbUser : await this.crypto.encryptData(this.breadCrumbUser);

    if (type.type == "Day") {
      this.usageDateRange = "daySelected";
      selectData = type.type.toLowerCase();
      count = 31;
      apiUrl = `/analytics/sessionsPlayedUsage?fromDate=${type.from}&gameId=${this.selectedApp.id}` + (dataID ? "&dataId=" + dataID : "") + (this.breadCrumbUser ? "&userName=" + nameStr : "");
      this.usageDates = moment(new Date()).subtract(1, "d").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type.type == "Month" || type.type == "month") {
      this.usageDateRange = "monthSelected";
      selectData = type.type.toLowerCase();
      count = 24;
      apiUrl = `/analytics/sessionsPlayedMonths?fromDate=${type.from}&gameId=${this.selectedApp.id}` + (dataID ? "&dataId=" + dataID : "") + (this.breadCrumbUser ? "&userName=" + nameStr : "");
      this.usageDates = moment(new Date()).subtract(1, "M").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type.type == "Year") {
      this.usageDateRange = "yearSelected";
      selectData = type.type.toLowerCase();
      count = 5;
      apiUrl = `/analytics/sessionsPlayedYear?fromDate=${type.from}&gameId=${this.selectedApp.id}` + (dataID ? "&dataId=" + dataID : "") + (this.breadCrumbUser ? "&userName=" + nameStr : "");
      this.usageDates = moment(new Date()).subtract(1, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
    } else if (type.type == "range") {
      this.usageDateRange = "rangeSelected";
      selectData = type.type.toLowerCase();
      date = type.date.split("&");
      startDate = date[0].split("=");
      endDate = date[1].split("=");
      apiUrl = `/analytics/sessionsPlayedCustomRange?${date[0]}&${date[1]}&gameId=${this.selectedApp.id}` + (dataID ? "&dataId=" + dataID : "") + (this.breadCrumbUser ? "&userName=" + nameStr : "");
    }
    type.count = count;
    let totalSessionPlayedList = [];
    let totalSessionPlayedAvgDurationList = [];
    let totalSessionMasterList = [];
    this.sessionPlayedChartDatasets = [];
    let incorrectSessionPlayedList = [];
    this.api.get(apiUrl).subscribe(
      (success) => {
        if (success && success[0]) {
          if (usageType === "averageDuration") {
            if (!_.isUndefined(success[0]["totalSessionDurationAvg"]) && success[0]["totalSessionDurationAvg"].length !== 0) {
              let totalSessionPlayedAvgDuration = success[0]["totalSessionDurationAvg"];
              totalSessionPlayedAvgDurationList = totalSessionPlayedAvgDuration.map((v) => Number(v));
            }
            this.sessionPlayedChartDatasets = [{ data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" }];
            const timepointPlayed = success?.[0]?.["Timepoint"];
            if (type.type !== "range") {
              if (timepointPlayed) {
                if (type.type === "month" || type.type === "Month") {
                  this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
                } else if (type.type === "year" || type.type === "Year") {
                  this.sessionPlayedChartLabels = timepointPlayed;
                } else {
                  this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
                }
              } else {
                this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(type);
              }
            } else {
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(startDate[1], endDate[1]);
              }
            }
            this.sessionPlayedChartColors = [
              {
                backgroundColor: "rgba(255, 255, 255, .2)",
                borderColor: "rgb(112, 0, 152)",
                borderWidth: 2,
              },
            ];
            this.highchartsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
            this.updateChart = true;
          } else if (usageType === "totalPlayedSession") {
            if (!_.isUndefined(success[0]["totalSessionPlayed"]) && success[0]["totalSessionPlayed"].length !== 0) {
              let totalSessionPlayed = success[0]["totalSessionPlayed"];
              totalSessionPlayedList = totalSessionPlayed.map((v) => Number(v));
            }
            this.sessionPlayedChartDatasets = [{ data: totalSessionPlayedList, label: "Total Practice Set Sessions" }];

            const timepointPlayed = success?.[0]?.["Timepoint"];

            if (type.type !== "range") {
              if (timepointPlayed) {
                if (type.type === "month" || type.type === "Month") {
                  this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
                } else if (type.type === "year" || type.type === "Year") {
                  this.sessionPlayedChartLabels = timepointPlayed;
                } else {
                  this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
                }
              } else {
                this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(type);
              }
            } else {
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(startDate[1], endDate[1]);
              }
            }
            this.sessionPlayedChartColors = [
              {
                backgroundColor: "rgba(255, 255, 255, .2)",
                borderColor: "rgb(215, 38, 61)",
                borderWidth: 2,
              },
            ];
            this.highchartsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
            this.updateChart = true;
          } else if (usageType === "incorrectSession") {
            if (!_.isUndefined(success[0]["incorrectSession"]) && success[0]["incorrectSession"].length !== 0) {
              let incorrectSessionPlayed = success[0]["incorrectSession"];
              incorrectSessionPlayedList = incorrectSessionPlayed.map((v) => Number(v));
            }
            this.sessionPlayedChartDatasets = [{ data: incorrectSessionPlayedList, label: "Incorrect Sessions" }];

            const timepointPlayed = success?.[0]?.["Timepoint"];
            if (type.type !== "range") {
              if (timepointPlayed) {
                if (type.type === "month" || type.type === "Month") {
                  this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
                } else if (type.type === "year" || type.type === "Year") {
                  this.sessionPlayedChartLabels = timepointPlayed;
                } else {
                  this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
                }
              } else {
                this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(type);
              }
            } else {
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(startDate[1], endDate[1]);
              }
            }
            this.sessionPlayedChartColors = [
              {
                backgroundColor: "rgba(255, 255, 255, .2)",
                borderColor: "rgba(255, 86, 3, 1)",
                borderWidth: 2,
              },
            ];
            this.highchartsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
            this.updateChart = true;
          } else if (usageType === "masteredPracticeSets") {
            if (!_.isUndefined(success[0]["totalSessionMastered"]) && success[0]["totalSessionMastered"].length !== 0) {
              let totalSessionMastered = success[0]["totalSessionMastered"];
              totalSessionMasterList = totalSessionMastered.map((v) => Number(v));
            }
            this.sessionPlayedChartDatasets = [{ data: totalSessionMasterList, label: "Mastered Practice Sets" }];

            const timepointPlayed = success?.[0]?.["Timepoint"];
            if (type.type !== "range") {
              if (timepointPlayed) {
                if (type.type === "month" || type.type === "Month") {
                  this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
                } else if (type.type === "year" || type.type === "Year") {
                  this.sessionPlayedChartLabels = timepointPlayed;
                } else {
                  this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
                }
              } else {
                this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(type);
              }
            } else {
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(startDate[1], endDate[1]);
              }
            }
            this.sessionPlayedChartColors = [
              {
                backgroundColor: "rgba(255, 255, 255, .2)",
                borderColor: "rgb(45, 134, 86)",
                borderWidth: 2,
              },
            ];
            this.highchartsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
            this.updateChart = true;
          } else {
            if (!_.isUndefined(success[0]["totalSessionPlayed"]) && success[0]["totalSessionPlayed"].length != 0) {
              let totalSessionPlayed = success[0]["totalSessionPlayed"];
              totalSessionPlayedList = totalSessionPlayed.map((v) => Number(v));
            }
            if (!_.isUndefined(success[0]["totalSessionDurationAvg"]) && success[0]["totalSessionDurationAvg"].length != 0) {
              let totalSessionPlayedAvgDuration = success[0]["totalSessionDurationAvg"];
              totalSessionPlayedAvgDurationList = totalSessionPlayedAvgDuration.map((v) => Number(v));
            }
            if (!_.isUndefined(success[0]["totalSessionMastered"]) && success[0]["totalSessionMastered"].length != 0) {
              let totalSessionMastered = success[0]["totalSessionMastered"];
              totalSessionMasterList = totalSessionMastered.map((v) => Number(v));
            }
            if (!_.isUndefined(success[0]["incorrectSession"]) && success[0]["incorrectSession"].length != 0) {
              let incorrectSessionPlayed = success[0]["incorrectSession"];
              incorrectSessionPlayedList = incorrectSessionPlayed.map((v) => Number(v));
            }
            this.sessionPlayedChartDatasets = [
              { data: totalSessionPlayedList, label: "Total Practice Set Sessions" },
              { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" },
              { data: totalSessionMasterList, label: "Mastered Practice Sets" },
              { data: incorrectSessionPlayedList, label: "Incorrect Sessions" },
            ];
            const timepointPlayed = success?.[0]?.["Timepoint"];
            if (type.type !== "range") {
              if (timepointPlayed) {
                if (type.type === "month" || type.type === "Month") {
                  this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
                } else if (type.type === "year" || type.type === "Year") {
                  this.sessionPlayedChartLabels = timepointPlayed;
                } else {
                  this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
                }
              } else {
                this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(type);
              }
            } else {
              if (timepointPlayed) {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
              } else {
                this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(startDate[1], endDate[1]);
              }
            }
            this.sessionPlayedChartColors = [
              {
                backgroundColor: "rgba(255, 255, 255, .2)",
                borderColor: "rgb(215, 38, 61)",
                borderWidth: 2,
              },
              {
                backgroundColor: "rgba(255, 255, 255, .2)",
                borderColor: "rgb(112, 0, 152)",
                borderWidth: 2,
              },
              {
                backgroundColor: "rgba(255, 255, 255, .2)",
                borderColor: "rgb(45, 134, 86)",
                borderWidth: 2,
              },
            ];
          }
          this.highchartsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
          this.updateChart = true;
        } else {
          this.sessionPlayedChartDatasets = [];
        }
      },
      (err) => {
        this.getError(err);
      }
    );

  }

  ngOnInit() {
    this.selectedApp = this.selectedApp == null ? JSON.parse(localStorage.getItem("selectedGame")) : this.selectedApp;
    this.route.params.subscribe((data) => {
      this.selectedApp = JSON.parse(localStorage.getItem("selectedApp"));
      if (this.psParams) {
        this.key = "pSetAnalytics";
        data = this.psParams;
        console.log(data);
      }
      if (data.id) {
        this.api.addRoute(0, data.name);
        localStorage.setItem("analyticsEnabled", "true");
        this.data.name = data.name;
        this.data.id = data.id;
        console.log(this.selectedApp);
        // this.getUsers({ type: 'day' });
        this.dateType = { type: "Day", from: moment(new Date()).format("YYYY-MM-DD"), to: moment(new Date()).subtract(30, "days").format("YYYY-MM-DD"), count: 30 };
        console.log(this.dateType);
        // ***********  SG-7203 start*************************
        // this.getListOfRecords({ type: 'day' });
        // this.getUsageRecords(this.dateType);
        // this.intiateLoad();
        // ***********  SG-7203 end*************************
      }
    });
    this.subSink = this.dateData$.pipe(debounceTime(500), distinctUntilChanged()).subscribe((next) => {
      if (next) {
        this.dateInfo = localStorage.getItem("dateRange");
        if (this.dateInfo) {
          next = JSON.parse(this.dateInfo);
        }
        this.selectedApp = JSON.parse(localStorage.getItem("selectedApp"));
        this.dateType = next;
        this.updateSelectedRange(next);
        this.getUsers(next);
        this.getListOfRecords(next);
        this.getUsageRecords(next, this.usageAnalyticsSelectedValue);
        this.intiateLoad();
      }
    });

  }

  updateSelectedRange(next) {
    if (next.type == "Day") {
      this.listDateRange = "daySelected";
    } else if (next.type == "Month" || next.type == "month") {
      this.listDateRange = "monthSelected";
    } else if (next.type == "Year") {
      this.listDateRange = "yearSelected";
    } else if (next.type == "range") {
      this.listDateRange = "rangeSelected";
    }
  }

  getCsvData(analyticsType) {
    let type = this.dateType.type.toLowerCase();
    this.api.getPsetsCsvData(analyticsType, type, this.data.id, this.dateType.date, null).subscribe(
      (data) => {
        if (data.type === "application/zip") {
          var blob = new Blob([data], { type: data.type });
          FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".zip");
        } else {
          var blob = new Blob([data], { type: "application/csv" });
          FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".csv");
        }
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  ngOnDestroy() {
    if (this.subSink) this.subSink.unsubscribe();
    this.api.changeMessage({ type: "Day" });
  }

  // Analytics Chart
  startDate: any;
  endDate: any;
  date: any = {};
  maxDate = new Date();
  today: any;
  listDateRange: any = "monthSelected";
  listDates: any = "";
  selectedDateForDay: any;
  masteredPracticeSetsForm: FormGroup;
  sessionPlayedChartType: string = "line";
  sessionPlayedChartDatasets: Array<any> = [];
  sessionPlayedChartLabels: Array<any> = [];
  sessionPlayedChartColors: Array<any> = [];
  selectedMonth: any;
  sessionPlayedChartOptions: any = { responsive: true };
  sessionPlayedTab = "monthSelected";
  masteredPSTab = "daySelected";
  menuSelectedButton: any = "all";
  selectedYear: any;
  selectedEndDate: any;
  selectedFromDate: any;
  sessionDay: any = "";
  sessionMonth: any = "";
  sessionYear: any = "";
  sessionDateRange: any = "";
  isShowDate: boolean = false;

  masteredPracticeChartType: string = "line";
  masteredPracticeChartDatasets: Array<any> = [];
  masteredPracticeChartLabels: Array<any> = [];
  masteredPracticeChartColors: Array<any> = [];
  masteredPracticeChartOptions: any = {
    responsive: true,
  };
  masterDay: any = "";
  masterMonth: any = "";
  masterYear: any = "";
  masterDateRange: any = "";
  showTableHeaders = false;
  leastDifficultPSetsList = [];
  mostDifficultPSetsList = [];
  totalDifficultPSets: any;
  usageAnalyticsSelectedValue: string = "all";
  usageAnalytics: UsageAnalytics[] = [
    { viewValue: "All", value: "all" },
    { viewValue: "Average Session Duration", value: "averageDuration" },
    { viewValue: "Total Practice Set Sessions", value: "totalPlayedSession" },
    { viewValue: "Mastered Practice Sets", value: "masteredPracticeSets" },
    { viewValue: 'Incorrect Sessions', value: 'incorrectSession' },
  ];
  sessionDateRang: string = "";
  isMessage: boolean = false;
  isEmptyData: boolean = false;
  userTimeZone: any;
  organizationId: any = "";
  userName: string = "";
  selectedSessionType: string;

  intiateLoad() {
    this.today = this.userTimeZone.format("YYYY-MM-DD");
    this.practiceSetSelected(this.listDateRange, "load");
    this.selectedDateForDay = this.today;
    this.getMasterDates(this.selectedDateForDay, "day");
  }

  // SESSION PLAYED SESSION chart

  sessionPlayedDaySelected(tab) {
    this.usageAnalyticsSelectedValue = "all";
    this.sessionPlayedTab = tab;
    this.menuSelectedButton = "all";
    this.selectedEndDate = "";
    this.selectedFromDate = "";
    this.getSessionDates(this.selectedDateForDay, "day");
    this.renderChartForSessionPlayedByDay(this.selectedDateForDay);
  }

  sessionPlayedMonthSelected(tab) {
    this.usageAnalyticsSelectedValue = "all";
    this.sessionPlayedTab = tab;
    this.menuSelectedButton = "all";
    this.selectedEndDate = "";
    this.selectedFromDate = "";
    this.selectedMonth = this.today;
    this.getSessionDates(this.selectedMonth, "month");
    this.renderChartForSessionPlayedByMonth(this.selectedMonth);
  }

  sessionPlayedYearSelected(tab) {
    this.usageAnalyticsSelectedValue = "all";
    this.sessionPlayedTab = tab;
    this.selectedEndDate = "";
    this.selectedFromDate = "";
    this.menuSelectedButton = "all";
    this.selectedYear = this.today;
    this.getSessionDates(this.selectedYear, "year");
    this.renderChartForSessionPlayedByYear(this.selectedYear);
  }

  onSessionPlayedDaySelect(event, tab) {
    this.sessionPlayedTab = "";
    this.selectedDateForDay = "";
    this.sessionPlayedTab = tab;
    this.menuSelectedButton = "";
    this.getSessionDates(moment(event.target.value).format("YYYY-MM-DD"), "day");
    this.selectedDateForDay = moment(event.target.value).format("YYYY-MM-DD");
    this.renderChartForSessionPlayedByDay(this.selectedDateForDay);
  }

  onSessionPlayedMonthSelect(event, tab) {
    this.sessionPlayedTab = "";
    this.selectedMonth = "";
    this.menuSelectedButton = "";
    this.sessionPlayedTab = tab;
    this.getSessionDates(moment(event.target.value).format("YYYY-MM-DD"), "month");
    this.selectedMonth = moment(event.target.value).format("YYYY-MM-DD");
    this.renderChartForSessionPlayedByMonth(this.selectedMonth);
  }

  onSessionPlayedYearSelect(event, tab) {
    this.sessionPlayedTab = "";
    this.selectedYear = "";
    this.menuSelectedButton = "";
    this.sessionPlayedTab = tab;
    this.getSessionDates(moment(event.target.value).format("YYYY-MM-DD"), "year");
    this.selectedYear = moment(event.target.value).format("YYYY-MM-DD");
    this.renderChartForSessionPlayedByYear(this.selectedYear);
  }

  renderChartForSessionPlayedByDay(date) {
    this.updateChart = false;
    this.sessionPlayedChartDatasets = [];
    this.analyticService.getSessionsPlayedByDay(date, this.selectedApp.id, this.breadCrumbUser, this.dataId).subscribe(
      (res) => {
        let dataList = res;
        this.sessionPlayedChartLabels = [];
        this.sessionPlayedChartColors = [];
        let totalSessionPlayedList = [];
        let totalSessionPlayedAvgDurationList = [];
        let totalSessionMasterList = [];
        let incorrectSessionPlayedList = [];
        this.sessionDateRang = moment(new Date()).subtract(1, "M").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
        if (!_.isUndefined(dataList)) {
          if (!_.isUndefined(dataList[0]["totalSessionPlayed"]) && dataList[0]["totalSessionPlayed"].length != 0) {
            let totalSessionPlayed = dataList[0]["totalSessionPlayed"];
            totalSessionPlayedList = totalSessionPlayed.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["totalSessionDurationAvg"]) && dataList[0]["totalSessionDurationAvg"].length != 0) {
            let totalSessionPlayedAvgDuration = dataList[0]["totalSessionDurationAvg"];
            totalSessionPlayedAvgDurationList = totalSessionPlayedAvgDuration.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["totalSessionMastered"]) && dataList[0]["totalSessionMastered"].length != 0) {
            let totalSessionMastered = dataList[0]["totalSessionMastered"];
            totalSessionMasterList = totalSessionMastered.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["incorrectSession"]) && dataList[0]["incorrectSession"].length != 0) {
            let incorrectSessionPlayed = dataList[0]["incorrectSession"];
            incorrectSessionPlayedList = incorrectSessionPlayed.map((v) => Number(v));
          }

          this.sessionPlayedChartDatasets = [
            { data: totalSessionPlayedList, label: "Total Practice Set Sessions" },
            { data: totalSessionPlayedAvgDurationList, label: "Average Session Duration" },
            { data: totalSessionMasterList, label: "Mastered Practice Sets" },
            { data: incorrectSessionPlayedList, label: "Incorrect Sessions" },
          ];
          const timepointPlayed = dataList?.[0]?.["Timepoint"];
          if (timepointPlayed) {
            if (date.type === "month" || date.type === "Month") {
              this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
            } else if (date.type === "year" || date.type === "Year") {
              this.sessionPlayedChartLabels = timepointPlayed;
            } else {
              this.sessionPlayedChartLabels = this.getLastThirtyDays(timepointPlayed);
            }
          } else {
              this.sessionPlayedChartLabels = this.getLastThirtyDaysDefault(date);
          }
          this.sessionPlayedChartColors = [
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(215, 38, 61)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(112, 0, 152)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(45, 134, 86)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgba(255, 86, 3, 1)",
              borderWidth: 2,
            },
          ];
        }
        this.highchartsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
        this.updateChart = true;
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  renderChartForSessionPlayedByMonth(date) {
    this.updateChart = false;
    this.sessionPlayedChartDatasets = [];
    this.analyticService.getSessionsPlayedByMonth(date, this.selectedApp.id, this.breadCrumbUser, this.dataId).subscribe(
      (res) => {
        let dataList = res;
        let totalSessionPlayedMonthList = [];
        let totalSessionDurationAvgMonthsList = [];
        let totalSessionMasterList = [];
        this.sessionPlayedChartDatasets = [];
        this.sessionPlayedChartLabels = [];
        this.sessionPlayedChartColors = [];
        let incorrectSessionPlayedList = [];
        this.sessionDateRang = moment(new Date()).subtract(2, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
        if (!_.isUndefined(dataList)) {
          if (!_.isUndefined(dataList[0]["totalSessionPlayed"]) && dataList[0]["totalSessionPlayed"].length != 0) {
            let totalSessionPlayedMonth = dataList[0]["totalSessionPlayed"];
            totalSessionPlayedMonthList = totalSessionPlayedMonth.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["totalSessionDurationAvg"]) && dataList[0]["totalSessionDurationAvg"].length != 0) {
            let totalSessionDurationAvgMonths = dataList[0]["totalSessionDurationAvg"];
            totalSessionDurationAvgMonthsList = totalSessionDurationAvgMonths.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["totalSessionMastered"]) && dataList[0]["totalSessionMastered"].length != 0) {
            let totalSessionMastered = dataList[0]["totalSessionMastered"];
            totalSessionMasterList = totalSessionMastered.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["incorrectSession"]) && dataList[0]["incorrectSession"].length != 0) {
            let incorrectSessionPlayed = dataList[0]["incorrectSession"];
            incorrectSessionPlayedList = incorrectSessionPlayed.map((v) => Number(v));
          }
          this.sessionPlayedChartDatasets = [
            { data: totalSessionPlayedMonthList, label: "Total Practice Set Sessions" },
            { data: totalSessionDurationAvgMonthsList, label: "Average Session Duration" },
            { data: totalSessionMasterList, label: "Mastered Practice Sets" },
            { data: incorrectSessionPlayedList, label: "Incorrect Sessions" },
          ];
          const timepointPlayed = dataList?.[0]?.["Timepoint"];
          if (timepointPlayed) {
            this.sessionPlayedChartLabels = this.getLastTwentyFourMonth(timepointPlayed);
          } else {
            this.sessionPlayedChartLabels = this.getLastTwentyFourMonthDefault(date);
          }
          this.sessionPlayedChartColors = [
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(215, 38, 61)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(112, 0, 152)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(45, 134, 86)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgba(255, 86, 3, 1)",
              borderWidth: 2,
            },
          ];
        }
        this.highchartsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
        this.updateChart = true;
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  renderChartForSessionPlayedByYear(date) {
    this.updateChart = false;
    this.sessionPlayedChartDatasets = [];
    this.analyticService.getSessionsPlayedByYear(date, this.selectedApp.id, this.breadCrumbUser, this.dataId).subscribe(
      (res) => {
        let dataList = res;
        let totalSessionPlayedYearList = [];
        let totalSessionDurationAvgYearsList = [];
        let totalSessionMasterList = [];
        this.sessionPlayedChartDatasets = [];
        this.sessionPlayedChartLabels = [];
        this.sessionPlayedChartColors = [];
        let incorrectSessionPlayedList = [];
        this.sessionDateRang = moment(new Date()).subtract(4, "y").format("MM/DD/YYYY") + " - " + moment(new Date()).format("MM/DD/YYYY");
        if (!_.isUndefined(dataList)) {
          if (!_.isUndefined(dataList[0]["totalSessionPlayed"]) && dataList[0]["totalSessionPlayed"].length != 0) {
            let totalSessionPlayedYear = dataList[0]["totalSessionPlayed"];
            totalSessionPlayedYearList = totalSessionPlayedYear.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["totalSessionDurationAvg"]) && dataList[0]["totalSessionDurationAvg"].length != 0) {
            let totalSessionDurationAvgYear = dataList[0]["totalSessionDurationAvg"];
            totalSessionDurationAvgYearsList = totalSessionDurationAvgYear.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["totalSessionMastered"]) && dataList[0]["totalSessionMastered"].length != 0) {
            let totalSessionMastered = dataList[0]["totalSessionMastered"];
            totalSessionMasterList = totalSessionMastered.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["incorrectSession"]) && dataList[0]["incorrectSession"].length != 0) {
            let incorrectSessionPlayed = dataList[0]["incorrectSession"];
            incorrectSessionPlayedList = incorrectSessionPlayed.map((v) => Number(v));
          }
          this.sessionPlayedChartDatasets = [
            { data: totalSessionPlayedYearList, label: "Total Practice Set Sessions" },
            { data: totalSessionDurationAvgYearsList, label: "Average Session Duration" },
            { data: totalSessionMasterList, label: "Mastered Practice Sets" },
            { data: incorrectSessionPlayedList, label: "Incorrect Sessions" },
          ];

          this.sessionPlayedChartLabels = this.getLastFiveYears(date);
          this.sessionPlayedChartColors = [
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(215, 38, 61)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(112, 0, 152)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(45, 134, 86)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgba(255, 86, 3, 1)",
              borderWidth: 2,
            },
          ];
        }
        this.highchartsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
        this.updateChart = true;
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  renderChartForSessionPlayedByDateRange(fromDate, toDate) {
    this.updateChart = false;
    this.usageAnalyticsSelectedValue = "all";
    this.menuSelectedButton = "all";
    this.analyticService.getSessionsPlayedByDateRange(fromDate, toDate, this.selectedApp.id, this.breadCrumbUser, this.dataId).subscribe(
      (res) => {
        let dataList = res;
        let totalSessionPlayedYearList = [];
        let totalSessionPlayedAvgDurationYearList = [];
        let totalSessionMasterList = [];
        let incorrectSessionPlayedList = [];
        this.sessionPlayedChartColors = [];
        this.sessionPlayedChartDatasets = [];
        this.sessionPlayedChartLabels = [];
        this.sessionPlayedChartColors = [];
        this.sessionDateRang = moment(fromDate).format("MM/DD/YYYY") + " - " + moment(toDate).format("MM/DD/YYYY");
        if (!_.isUndefined(dataList)) {
          if (!_.isUndefined(dataList[0]["totalSessionPlayed"]) && dataList[0]["totalSessionPlayed"].length != 0) {
            let totalSessionPlayedYear = dataList[0]["totalSessionPlayed"];
            totalSessionPlayedYearList = totalSessionPlayedYear.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["totalSessionDurationAvg"]) && dataList[0]["totalSessionDurationAvg"].length != 0) {
            let totalSessionPlayedAvgDurationYear = dataList[0]["totalSessionDurationAvg"];
            totalSessionPlayedAvgDurationYearList = totalSessionPlayedAvgDurationYear.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["totalSessionMastered"]) && dataList[0]["totalSessionMastered"].length != 0) {
            let totalSessionMastered = dataList[0]["totalSessionMastered"];
            totalSessionMasterList = totalSessionMastered.map((v) => Number(v));
          }
          if (!_.isUndefined(dataList[0]["incorrectSession"]) && dataList[0]["incorrectSession"].length != 0) {
            let incorrectSessionPlayed = dataList[0]["incorrectSession"];
            incorrectSessionPlayedList = incorrectSessionPlayed.map((v) => Number(v));
          }
          this.sessionPlayedChartDatasets = [
            { data: totalSessionPlayedYearList, label: "Total Practice Set Sessions" },
            { data: totalSessionPlayedAvgDurationYearList, label: "Average Session Duration" },
            { data: totalSessionMasterList, label: "Mastered Practice Sets" },
            { data: incorrectSessionPlayedList, label: "Incorrect Sessions" },
          ];

          const timepointPlayed = dataList?.[0]?.["Timepoint"];
          if (timepointPlayed) {
            this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEnd(timepointPlayed);
          } else {
            this.sessionPlayedChartLabels = this.getDatesBetweenStartAndEndDefault(fromDate, toDate);
          }
          this.sessionPlayedChartColors = [
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(215, 38, 61)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(112, 0, 152)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgb(45, 134, 86)",
              borderWidth: 2,
            },
            {
              backgroundColor: "rgba(255, 255, 255, .2)",
              borderColor: "rgba(255, 86, 3, 1)",
              borderWidth: 2,
            },
          ];
        }
        this.highchartsComponent.updateChartData(this.sessionPlayedChartLabels, this.sessionPlayedChartDatasets);
        this.updateChart = true;
      },
      (err) => {
        this.getError(err);
      }
    );
  }

  changeAnalytics(value) {
    this.usageAnalyticsSelectedValue = value;
    if (value == "averageDuration") {
      this.selectedUsage = "totalSessionDurationAvg";
    } else if (value == "totalPlayedSession") {
      this.selectedUsage = "totalSessionPlayed";
    } else if (value == "masteredPracticeSets") {
      this.selectedUsage = "totalSessionMastered";
    } else if (value == "incorrectSession") {
      this.selectedUsage = "incorrectSession";
    }
    this.getUsageRecords(this.dateType, this.usageAnalyticsSelectedValue);
  }

  clearDate(event) {
    event.stopPropagation();
    this.isShowDate = false;
    this.listDateRange = "";
    this.date = {};
    this.practiceSetSelected("daySelected", "load");
  }

  clearSessionDate(event) {
    event.stopPropagation();
    this.sessionDateRange = "";
    this.selectedFromDate = "";
    this.selectedEndDate = "";
    this.sessionPlayedTab = "daySelected";
    this.usageAnalyticsSelectedValue = "all";
    this.menuSelectedButton = "all";
    this.renderChartForSessionPlayedByDay(this.selectedDateForDay);
  }

  // Utility

  getNameSuffix(name) {
    let res: string = "";
    if (!_.isUndefined(name) && (name != null || name != "")) {
      let splitNameList: any = name.trim().split(" ");
      if (splitNameList.length == 1) res = splitNameList[0].substring(0, 1).toUpperCase() + "" + splitNameList[0].substring(1, 2).toUpperCase();
      else res = splitNameList[0].substring(0, 1).toUpperCase() + "" + splitNameList[1].substring(0, 1).toUpperCase();
    }
    return res;
  }

  getLastTwentyFourMonthDefault(date) {
    let months = [];
    for (var i = 0; i < 24; i++) {
      var selectedMonth = moment(date).subtract(i, "months");
      months.push(moment(selectedMonth).format("MMM YYYY"));
    }
    return months.reverse();
  }

  getLastFiveYears(date) {
    let years = [];
    for (var i = 0; i < 5; i++) {
      var selectedYear = moment(date).subtract(i, "years");
      years.push(moment(selectedYear).format("YYYY"));
    }
    return years.reverse();
  }

  getError(err) {
    if (err.status == 401) {
      this.api.notifyInfo(AlertMessage.exitingCurrentSession);
      this.api.logmeout();
    }
  }

  getMasterDates(data, tab) {
    this.masterDay = "";
    this.masterMonth = "";
    this.masterYear = "";
    this.masterDateRange = "";
    if (tab == "day") this.masterDay = data;
    else if (tab == "month") this.masterMonth = moment(data).format("MMMM YYYY");
    else if (tab == "year") this.masterYear = moment(data).format("YYYY");
    else if (tab == "range") this.masterDateRange = data;
  }

  getSessionDates(data, tab) {
    this.sessionDay = "";
    this.sessionMonth = "";
    this.sessionYear = "";
    this.sessionDateRange = "";
    if (tab == "day") this.sessionDay = data;
    else if (tab == "month") this.sessionMonth = moment(data).format("MMMM YYYY");
    else if (tab == "year") this.sessionYear = moment(data).format("YYYY");
    else if (tab == "range") this.sessionDateRange = data;
  }

  openFolderAnalyticsView(data) {
    if (data.folder !== null) {
      this.router.navigate(["main/folderAnalytics", data.folderId, data.folder]);
    }
  }

  openPracSetAnalyticsView(data) {
    this.api.addRoute(0, this.selectedApp.title, this.selectedApp.id);
    this.router.navigate(["main/practiceSet/analytics", data.praticeSetId, data.name]);
  }

  async exportCsvData(analyticsType) {
    let dateType;
    if (this.listDateRange == "daySelected") dateType = "day";
    else if (this.listDateRange == "monthSelected") dateType = "month";
    else if (this.listDateRange == "yearSelected") dateType = "year";
    else if (this.listDateRange == "rangeSelected") {
      dateType = "range";
    }
    let requestParam = "";
    if (analyticsType === "usage" && !_.isUndefined(this.selectedSessionType) && this.selectedSessionType != "all") {
      if (this.selectedSessionType === "averageDuration") {
        this.selectedSessionType = "totalSessionDurationAvg";
      } else if (this.selectedSessionType === "masteredPracticeSets") {
        this.selectedSessionType = "totalSessionMastered";
      } else if (this.selectedSessionType === "incorrectSession") {
        this.selectedSessionType = "incorrectSession";
      } else {
        this.selectedSessionType = "totalSessionPlayed";
      }
      requestParam = "&selectedUsageType=" + this.selectedSessionType;
    }
    try {
      let nameStr = this.crypto.isProbablyEncrypted(this.breadCrumbUser) ? this.breadCrumbUser : await this.crypto.encryptData(this.breadCrumbUser);

      this.analyticService.getCsvData(analyticsType, dateType, this.startDate, this.endDate, this.selectedApp.id, requestParam, nameStr, this.dataId).subscribe(
        (data) => {
          let dataObject: any = data;
          if (data.type === "application/zip") {
            var blob = new Blob([data], { type: data.type });
            FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".zip");
          } else {
            var blob = new Blob([data], { type: "application/csv" });
            FileSaver.saveAs(blob, analyticsType.toUpperCase() + ".csv");
          }
        },
        (err) => {
          this.getError(err);
        }
      );
    } catch (error) { }
  }

  practiceSetSelected(data, type) {
    this.isShowDate = false;
    this.isMessage = false;
    let selectData: string = "";
    if (data == "daySelected") {
      this.listDateRange = "daySelected";
      selectData = "day";
      this.listDates = moment(new Date()).subtract(1, "d").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    } else if (data == "monthSelected") {
      this.listDateRange = "monthSelected";
      selectData = "month";
      this.listDates = moment(new Date()).subtract(1, "M").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    } else if (data == "yearSelected") {
      this.listDateRange = "yearSelected";
      selectData = "year";
      this.listDates = moment(new Date()).subtract(1, "y").format("YYYY-MM-DD") + " To " + moment(new Date()).format("YYYY-MM-DD");
    } else if (data == "rangeSelected") {
      let dateRange = JSON.parse(localStorage.getItem("dateRange"));
      if (dateRange.type == "range") {
        this.startDate = moment(dateRange.startDate).format("YYYY-MM-DD");
        this.endDate = moment(dateRange.endDate).format("YYYY-MM-DD");
      }
      //this.difficultPSetsOnDateRange(this.startDate, this.endDate);
      return;
    }
    this.totalDifficultPSets = [];
    this.isEmptyData = true;
  }

  difficultPSetsOnDateRange(startDate, endDate) {
    this.leastDifficultPSetsList = [];
    this.totalDifficultPSets = [];
    this.isMessage = false;
    this.isEmptyData = true;

    this.analyticService.getLessonRecordsOnDateRangeSets(startDate, endDate, this.dataId, this.breadCrumbUser).subscribe(
      (res) => {
        let data: any = res;
        this.listDateRange = moment(startDate).format("MM/DD/YYYY") + " - " + moment(endDate).format("MM/DD/YYYY");
        this.isShowDate = true;
        this.listDates = moment(startDate).format("MM/DD/YYYY") + " - " + moment(endDate).format("MM/DD/YYYY");
        if (!_.isUndefined(data)) {
          if (data.sessionsPlayed > 0) this.isEmptyData = false;
          else {
            this.isEmptyData = false;
            this.isMessage = true;
          }
          if (!_.isUndefined(data)) {
            this.leastDifficultPSetsList = data;
            this.totalDifficultPSets = data;
          }
        } else this.totalDifficultPSets = [];
      },
      (err) => {
        this.getError(err);
        this.isEmptyData = false;
        this.isMessage = true;
      }
    );
  }
}

